import React from 'react'
import career from "../../assets/images/04_Animated Armory Shield.webm"
import careerbox from "../../assets/images/box6.png"
import useFlickerEffect from '../../hooks/useFlickerEffect.ts';

const Career = () => {

    const activeClass = useFlickerEffect();

    return (
        <>
            <section
                className={`relative 
                after:block
                after:absolute after:right-0 
                ${activeClass && 'after:animate-flicker'} 
                after:top-[-1200px] sm:after:top-[-600px] md:after:top-[-1050px] lg:after:top-[-1000px] xl:after:top-[-950px] 
                after:w-[280px] sm:after:w-[600px] md:after:w-[400px] lg:after:w-[450px] xl:after:w-[500px] 
                after:h-[800px] sm:after:h-[1000px] md:after:h-[1200px] xl:after:h-[1400px]
                after:bg-[url('../src/assets/images/righteffect1.png')] 
                after:bg-no-repeat
                after:bg-contain
                after:z-[-1]`
            }
                id='careers'
            >
                <div className='container' >
                    <h2 style={{ textShadow: "0px 0px 20px #2972D7" }} className='pb-[20px] md:pb-[60px] text-nowrap text-[28px] md:text-[32px]  lg:text-[40px] xl:text-[50px] text-white text-center font-gothicproMedium leading-[52px]  drop-shadow-custom relative z-20 '>// CAREERS</h2>
                    <div className='space-y-8' >
                        <h3 className='lg:text-[24px] md:text-[20px] text-[20px] leading-[100%] lg:leading-[110%] text-center font-gothicproMedium text-[#E2EEFF]' >
                            Join  <span className='text-[#2972D7]' >
                                ARMORY
                            </span>  and push the boundaries of cybersecurity
                        </h3>
                    </div>

                    <div className='flex lg:flex-row md:flex-row flex-col items-center gap-8 lg:gap-5 gap-5 max-w-[1082px] w-full mx-auto md:pt-[48px] pt-[28px] ' >
                        <video
                            className='rounded-lg w-[309px] h-[341.6px] md:w-[272px] md:h-[300.7px] lg:w-[291.7px] lg:h-[322.47px]'
                            src={career}
                            autoPlay
                            loop
                            muted
                            playsInline
                            aria-label="Animated Armory Shield"
                        />
                        <div className='relative max-w-[564px] w-full flex flex-col items-center '>
                            <img className='absolute  w-full min-h-[212px] lg:min-h-[220px] md:min-h-[242px]  h-[212px] lg:bottom-[-40px] md:bottom-[-40px] bottom-[-100px]' src={careerbox} alt="whiterborder" />
                            <div className='md:px-[47px] px-[50px] sm:relative top-[20px] lg:top-[0px] md:top-[0px]'>
                                <div className='flex items-start flex-col md:gap-5 gap-2  '>
                                    <p className=' text-start text-[16px]  leading-[140%] font-inter font-normal text-[#C9C9C9]'>Work alongside experts, tackle real-world threats, and build solutions that outsmart attackers.</p>
                                    <p className=' text-start text-[16px]  leading-[140%] font-inter font-normal text-[#C9C9C9]'>To be part of the team, send your resume to:</p>
                                    <a
                                        href="mailto:hr@armorydefense.com"
                                        style={{ textShadow: "0px 0px 20px #2972D7" }}
                                        className="text-start text-nowrap text-[20px] lg:text-[24px]  text-white font-gothicproMedium lg:leading-[110%] leading-[100%] drop-shadow-custom relative z-20"
                                    >
                                        hr@armorydefense.com
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </section >
        </>
    )
}

export default Career
